export default function () {
    $('body').removeClass("show-blog-popup");
    const current = new Date();
    localStorage.setItem("blogReminder", current);
}